import { useEffect } from 'react';

// De hoogte van het zichtbare venster op de telefoon. Opent het toetsenbord, dan krimpt op iOS niet
// de pagina maar alleen het zichtbare deel, en schuift Safari de pagina omhoog: de bovenkant van de
// app verdwijnt en de instructiebalk staat achter het toetsenbord. Daarom zet de schil `--vvh` op
// de hoogte van visualViewport (klasse h-app) en houdt hij de pagina bovenaan.

export interface ViewportLike {
  height: number;
  offsetTop: number;
}

export interface RootLike {
  style: { setProperty(name: string, value: string): void; removeProperty(name: string): void };
}

/** Zet `--vvh` op de hoogte van het zichtbare venster (of haalt hem weg); geeft terug of de pagina terug naar boven moet. */
export function applyVisualViewport(vv: ViewportLike | null, root: RootLike): boolean {
  if (!vv) {
    root.style.removeProperty('--vvh');
    return false;
  }
  root.style.setProperty('--vvh', `${Math.round(vv.height)}px`);
  return vv.offsetTop > 0;
}

export function useVisualViewport(enabled: boolean): void {
  useEffect(() => {
    const vv = window.visualViewport;
    const root = document.documentElement;
    if (!enabled || !vv) {
      applyVisualViewport(null, root);
      return;
    }
    const update = () => {
      if (applyVisualViewport(vv, root)) window.scrollTo(0, 0);
    };
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
      applyVisualViewport(null, root);
    };
  }, [enabled]);
}
